import React from 'react';
import { Footer, FooterMobile, HeaderB2B, HeaderB2BMobile } from 'components';
import { Helmet } from 'react-helmet';
import Spotlight from 'components/article/Spotlight';
import Others from 'components/article/Other';

export default function News({ isMobile = false }) {
  const pageMeta = {
    title: 'Berita Terbaru Electrum',
    description:
      'Dapatkan berita terbaru dan informasi terkini seputar Electrum dan perkembangan ekosistem motor listrik di Indonesia.',
    keywords: 'electrum, berita, news, motor listrik, EV, update',
  };

  return (
    <div>
      <Helmet>
        <title>{pageMeta.title}</title>
        <meta name="title" content={pageMeta.title} />
        <meta name="description" content={pageMeta.description} />
        <meta name="keywords" content={pageMeta.keywords} />
        <meta property="og:title" content={pageMeta.title} />
        <meta property="og:description" content={pageMeta.description} />
        <link rel="canonical" href="https://electrum.id/news" />
      </Helmet>

      {isMobile ? <HeaderB2BMobile /> : <HeaderB2B />}

      {/* SPOTLIGHT */}
      <Spotlight title="Topik Hangat" category="news" />

      {/* OTHER NEWS */}
      <Others title="Berita Terbaru" category="news" />

      {isMobile ? <FooterMobile /> : <Footer />}
    </div>
  );
}
